import { TextField, Title } from '../common';
import { useTranslation } from '../../hooks/translations/TranslationProvider';
import useSeo from '../../hooks/useSeo';

import './terms.css';

const Terms = () => {
    const { t } = useTranslation();
    useSeo({
        title: t('seo.terms.title'),
        description: t('seo.terms.description'),
        path: '/terms',
    });

    return (
        <div className="terms">
            <Title text={t('terms.acceptance.title')} />
            <TextField>{t('terms.acceptance.body')}</TextField>
            <Title text={t('terms.informationWeCollect.title')} />
            <TextField>{t('terms.informationWeCollect.body')}</TextField>
            <Title text={t('terms.purposeOfProcessing.title')} />
            <TextField>{t('terms.purposeOfProcessing.body')}</TextField>
            <Title text={t('terms.legalBasis.title')} />
            <TextField>{t('terms.legalBasis.body')}</TextField>
            <Title text={t('terms.dataSharing.title')} />
            <TextField>{t('terms.dataSharing.body')}</TextField>
            <Title text={t('terms.yourRights.title')} />
            <TextField>{t('terms.yourRights.body')}</TextField>
            <Title text={t('terms.contact.title')} />
            <TextField>{t('terms.contact.body')}</TextField>
        </div>
    );
};

export default Terms;
